import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import './AddStatusModal.css';

const PRESET_COLORS = [
  '#3b82f6', '#10b981', '#f59e0b', '#8b5cf6', '#ec4899',
  '#06b6d4', '#f97316', '#84cc16', '#6366f1', '#14b8a6',
  '#ef4444', '#22c55e', '#eab308', '#a855f7', '#f43f5e',
  '#0ea5e9', '#fb923c', '#4ade80', '#818cf8', '#2dd4bf',
];

export default function AddStatusModal({ onSubmit, onCancel }) {
  const [name, setName] = useState('');
  const [color, setColor] = useState('#3b82f6');
  const [description, setDescription] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim()) {
      setError('Status name is required');
      return;
    }
    setError('');
    setSubmitting(true);
    try {
      await onSubmit({ name: name.trim(), color, description: description.trim() || null });
    } catch (err) {
      setError(err?.response?.data?.error || err.message || 'Failed to create status');
      setSubmitting(false);
    }
  };

  return ReactDOM.createPortal(
    <div className="add-status-overlay" onClick={onCancel}>
      <div className="add-status-modal" onClick={(e) => e.stopPropagation()}>
        <h3 className="add-status-title">Add Custom Status</h3>
        <form onSubmit={handleSubmit}>
          <div className="add-status-field">
            <label className="add-status-label">Name *</label>
            <input
              type="text"
              className="add-status-input"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="e.g. On Hold, Review"
              autoFocus
              maxLength={50}
            />
          </div>

          <div className="add-status-field">
            <label className="add-status-label">Color</label>
            <div className="add-status-colors">
              {PRESET_COLORS.map((c) => (
                <button
                  key={c}
                  type="button"
                  className={`add-status-color-swatch${color === c ? ' selected' : ''}`}
                  style={{ backgroundColor: c }}
                  onClick={() => setColor(c)}
                  title={c}
                />
              ))}
            </div>
          </div>

          <div className="add-status-field">
            <label className="add-status-label">Description</label>
            <textarea
              className="add-status-textarea"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Optional description for this status"
              rows={2}
              maxLength={200}
            />
          </div>

          {error && <div className="add-status-error">{error}</div>}

          <div className="add-status-actions">
            <button type="button" className="add-status-btn add-status-cancel" onClick={onCancel}>
              Cancel
            </button>
            <button type="submit" className="add-status-btn add-status-submit" disabled={submitting}>
              {submitting ? 'Creating...' : 'Create Status'}
            </button>
          </div>
        </form>
      </div>
    </div>,
    document.body
  );
}
